import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {BasicInformationComponent} from './basic-information/basic-information.component';
import {NewRequestConfirmComponent} from './new-request-confirm/new-request-confirm.component';
import {OfferComponent} from './offer/offer.component';
import {RequestDetailsComponent} from './request-details/request-details.component';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {individualAccidentsRoutes} from './individual-accidents-routes';
import {NotFoundModule} from '../not-found/not-found.module';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {MatRadioModule} from '@angular/material/radio';
import {FinanceInvoiceDivModule} from '../../Elements/finance-invoice-div/finance-invoice-div.module';
import {FormModule} from '../../Elements/form/form.module';


@NgModule({
  declarations: [MainMenuComponent,
    BasicInformationComponent,
    NewRequestConfirmComponent,
    OfferComponent,
    RequestDetailsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(individualAccidentsRoutes),
    FormsModule,
    ReactiveFormsModule,
    NotFoundModule,
    CustomButtonModule,
    MainNavBarModule,
    FormListGeneratorModule,
    DetailsDivModule,
    MatRadioModule,
    FinanceInvoiceDivModule,
    FormModule
  ]
})
export class IndividualAccidentsModule {
}
